"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scalePermissions = void 0;
var enum_1 = require("../enum");
exports.scalePermissions = [enum_1.Permissions.CanCreateOwnUserType];
